 document.addEventListener("DOMContentLoaded", function () {

 const checkbox = document.querySelector(".kaching-bundles__subscriptions__checkbox");
  const subtitle = document.querySelector(".kaching-bundles__subscriptions__subtitle");
  const customText = document.querySelector("#subscription-message");
  const card = document.querySelector(".kaching-bundles__subscriptions__card");

  if (checkbox && subtitle && customText && card) {
    // Move text right after subtitle
    subtitle.insertAdjacentElement("afterend", customText);

    function toggleMessage() {
      const hasSvg = checkbox.querySelector("svg") !== null;

      // Show/hide custom message
      customText.style.display = hasSvg ? "block" : "none";

      // Add/remove active class on card
      if (hasSvg) {
        card.classList.add("active");
      } else {
        card.classList.remove("active");
      }
    }

    toggleMessage();

    // Watch for changes inside checkbox
    const observer = new MutationObserver(toggleMessage);
    observer.observe(checkbox, { childList: true, subtree: true });
  }

  if (checkbox) {
    function toggleMessage() {
      const hasSvg = checkbox.querySelector("svg") !== null;
      // Select all subtitles
      const subtitles = document.querySelectorAll(".kaching-bundles .kaching-bundles__bar-content");
      subtitles.forEach(function(subtitle) {
        const oneTime = subtitle.querySelector(".free_shipping_sub");
        if (oneTime) {
          if (hasSvg) {
            oneTime.style.display = "inline";
            subtitle.classList.remove("removed");
           
          } else {
            oneTime.style.display = "none";
              subtitle.classList.add("removed");
          }
        }
      });
    }

    // Run once at start
    toggleMessage();

    // Observe changes inside the checkbox
    const observer = new MutationObserver(toggleMessage);
    observer.observe(checkbox, { childList: true, subtree: true });
  }
});







